import styled from 'styled-components';

export const H1 = styled.h1`
    font-weight: 500;
    font-size: 40px;
    line-height: 40px;
    color: whitesmoke;
    margin-bottom: 15px;
    background: linear-gradient(45deg, #330055, #dd00ff 60%);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-shadow: 1px 1px 4px #330055bb;
`;
